import { Component, Inject, OnInit } from '@angular/core';
import { OregonWellDataService } from '../../../../services/oregon-well-data.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { IWellViewModel } from '../../../../models/well/well.viewmodel';
import { IAddSampleDataViewModel, SampleViewModel } from '../../../../models/well/samples/sample.viewmodel';
import { VoucherService } from '../../../../services/voucher-service';
import { Voucher } from '../../../../models/vouchers/voucher';

@Component({
  selector: 'app-add',
  templateUrl: './add-samples.component.html',
  styleUrls: ['./add-samples.component.scss']
})
export class AddSampleComponent implements OnInit {
  // #region component

  sampleViewModel: SampleViewModel = {
      regexZipCode: '',
      well: null,
      wellId: 0,
      sampleId: 0,
      wellAddress1: '',
      wellAddress2: '',
      wellCity: '',
      wellState: '',
      wellZip: '',
      wellCounty: '',
      wellLatitude: 0,
      wellLongitude: 0,
      samplePoint: '',
      createDate: '',
      createDateLabel: '',
      collectionDate: '',
      collectionDateLabel: '',
      stampedDate: '',
      stampedDateLabel: '',
      wellTag: '',
      wellDepth: 0,
      wellDepthAsString: '',
      wellLocation: '',
      wellComment: '',
      qa: '',
      qaFixComment: '',
      labName: '',
      labAddress1: '',
      labAddress2: '',
      labCity: '',
      labState: '',
      labZip: '',
      labCounty: '',
      labEmail: '',
      labPhone: '',
      labContact: '',
      orelap: '',
      retOrNot: '',
      wellTownship: '',
      wellRange: '',
      wellSection: '',
      wellTaxLot: '',
      pNWWQXSampleId: 0,
      parameterResult: '',
      parameterResults: [],
      parameterUnitId: '',
      parameterMethodId: '',
      parameterLabDetailsId: '',
      parameterIsReTest: false,
      parameterExceedence: false,
      parameterCompleteId: '',
      methods: [],
      labViewModel: [],
      submitButton: '',
      deleteParameterResult: false,
      isSampleReTest: false,
      sampleReTestComment: '',
      origin: '',
      postTreatment: false,
      overrideLatLong: false,
      lookupAddress: '',
      lookupCity: '',
      lookupState: '',
      lookupZip: '',
      voucherId: '',
      testType: '',
      treatmentId: 0,
      housingUnitId: 0,
    }

  id = 0;
  contaminantMsg = "";
  saved = false;
  postError = false;
  postErrorMessages = [];
  processing = false;
  overrideDisabled: boolean = true;
  wellId:number = 0;
  sampleId:number = 0;
  vouchers: Voucher[] = [];

  wellViewModel: IWellViewModel = undefined;

   // #endregion

  constructor(public oregonWellDataService: OregonWellDataService, 
              @Inject(MAT_DIALOG_DATA) public data: IAddSampleDataViewModel, 
              public dialogRef: MatDialogRef<AddSampleComponent>,
              private voucherService: VoucherService) {

    this.processing = true;
      
    
    this.wellId = this.data.wellId;
    this.sampleId = this.data.sampleId;

  }

  ngOnInit() {
    this.setUp();
  }

  setUp() {


    this.oregonWellDataService.GetEditWell(this.wellId).subscribe(result => {
      this.wellViewModel = result;
    },
      error => {
        this.oregonWellDataService.onHttpError(error);
      }
    );

    this.oregonWellDataService.GetAddSample(this.sampleId).subscribe(result => {
      this.sampleViewModel = result;

      if(result.retOrNot == null || result.retOrNot == ""){
        this.sampleViewModel.retOrNot = "RET";
      }
      
      if(result.qa == null || result.qa == ""){
        this.sampleViewModel.qa = "No";
      }
      if(result.origin == null || result.origin == ""){
        this.sampleViewModel.origin = 'OHA';
      }
      
      this.sampleViewModel.wellId = this.wellId;

      this.voucherService.getVouchersByWellId(this.sampleViewModel.wellId).subscribe(voucherResult => {
        this.vouchers = voucherResult;
        this.setFormFields();
        this.processing = false;
      },
        error => {
          this.oregonWellDataService.onHttpError(error);
          this.setFormFields();
          this.processing = false;
        }
     );
      this.setFormFields();

      this.processing = false;
    },
      error => {
        this.oregonWellDataService.onHttpError(error);
        this.processing = false;
      }
    );
  }

  ensureNumbersForParameterResults() {
    
    for (let i = 0; i < this.sampleViewModel.parameterResults.length; i++) {
      //ensure all units are numbers
      if(this.sampleViewModel.parameterResults[i].parameterUnitId != undefined && this.sampleViewModel.parameterResults[i].parameterUnitId != null) {
        this.sampleViewModel.parameterResults[i].parameterUnitId = +this.sampleViewModel.parameterResults[i].parameterUnitId
      }
      //ensure all methods are numbers
      if(this.sampleViewModel.parameterResults[i].parameterMethodId != undefined && this.sampleViewModel.parameterResults[i].parameterMethodId != null) {
        this.sampleViewModel.parameterResults[i].parameterMethodId = +this.sampleViewModel.parameterResults[i].parameterMethodId
      }
      //ensure all labs are numbers
      if(this.sampleViewModel.parameterResults[i].parameterLabDetailsId != undefined && this.sampleViewModel.parameterResults[i].parameterLabDetailsId != null) {
        this.sampleViewModel.parameterResults[i].parameterLabDetailsId = +this.sampleViewModel.parameterResults[i].parameterLabDetailsId
      }
    }
  }

  onSubmit() {
    this.processing = true;
    this.postError = false;
    this.sampleViewModel.createDate = this.requestForm.value.createDate;
    this.ensureNumbersForParameterResults();
    
    this.oregonWellDataService.AddSample(this.sampleViewModel).subscribe(
      result => {
        this.sampleViewModel = result;
        this.saved = true;
        this.processing = false;
        this.oregonWellDataService.showToastSucess("Sample was Added");
        this.processing = false;
        this.dialogRef.close();
      },
      error => {
        this.postError = true;
        this.processing = false;
        this.processing = false;
        this.postErrorMessages = this.oregonWellDataService.onHttpError(error);
      }
    );
  }

  requestForm = new FormGroup({
    createDate: new FormControl('')
  });
  
  setFormFields() {
    this.requestForm.get("createDate").setValue((new Date(this.sampleViewModel.createDate).toDateString()));
    this. ensureNumbersForParameterResults();
  }

  // #region helpers
 
  addParameterResult() {
    const parameterResult: any = {
      parameterCompleteId: null,
      parameterResult: '',
      parameterUnitId: null,
      parameterMethodId: null,
      parameterLabDetails: null,
      parameterIsReTest: false,
      parameterExceedence: null,
      deleteParameterResult: false
    };

    this.sampleViewModel.parameterResults.push(parameterResult);
  }

  removeParameterResult(id: number) {
    this.sampleViewModel.parameterResults[id]["deleteParameterResult"] = true;
    this.sampleViewModel.parameterResults.splice(id, 1);
    this.contaminantChange();
  }

  labChange(id, orelapId) {
    if (id === 0) {
      for (const i in this.sampleViewModel.parameterResults) {
        const temp = this.sampleViewModel.parameterResults[i] as any;
        temp.parameterLabDetailsId = orelapId;
      }
    }
  }

  contaminantChange() {
    const contaminants = [];

    for (const i in this.sampleViewModel.parameterResults) {
      const temp = this.sampleViewModel.parameterResults[i] as any;
      contaminants.push(temp.parameterCompleteId.toString());
    }

    const duplicates = contaminants.filter((item, index) => contaminants.indexOf(item) !== index);

    if (duplicates.length !== 0) {
      this.contaminantMsg = "You have a duplicate Contaminant. Please verify you entered the correct Contaminant";
    }
    else {
      this.contaminantMsg = "";
    }
  }

  countyLookup(address, city, zip) {
    const lookup = address + "," + city + "," + zip;

    this.oregonWellDataService.lookupCountyLatLong(lookup).subscribe(result => {
      const data = result;
      this.sampleViewModel.lookupAddress = data[0];
      this.sampleViewModel.lookupCity = data[1];
      this.sampleViewModel.lookupState = "OR";
      this.sampleViewModel.lookupZip = data[2];
      this.sampleViewModel.wellCounty = data[3];
      this.sampleViewModel.wellLongitude = data[4];
      this.sampleViewModel.wellLatitude = data[5];
    },
      error => {
        this.oregonWellDataService.onHttpError(error);

        this.processing = false;
      }
    );
  }

  overrideLatLong() {
    this.overrideDisabled = !this.overrideDisabled;
  }

  // #endregion
}